<section class="container-wrapper">
  <h1 class="module-heading">
    {{ 'pages.user-cards.list.heading.my-card' | translate }}
    <div class="loading-spinner" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20">
      </mat-progress-spinner>
    </div>
  </h1>
  <div class="module-content" *ngIf="!loading">
    <div class="selected-card-wrapper" #activeCard>
      <app-card
        *ngIf="!familyCardActive"
        [card]="feWallet[selectedCardType]"
        [user]="userRecord"
        [orgAndConfig]="cardConfigData"
        (cardActions)="handleCardActions($event)"
        class="user-card">
      </app-card>
      <app-user-family-card
        *ngIf="familyCardActive"
        [card]="activeWallet[selectedCardType]"
        [orgAndConfig]="cardConfigData"
        
        class="user-card"
        #familyCard>
      </app-user-family-card>
    </div>
    <div class="available-cards-wrapper" *ngIf="selectableCards.length > 0">
      <h3>{{ 'pages.user-cards.list.heading.wallet' | translate }}</h3>
      <p>{{ 'pages.user-cards.list.heading.wallet-instructions' | translate }}</p>
      <button *ngFor="let card of selectableCards"
        mat-button
        [class]="'bciti-button card-button card-' + card.cardType + ' ' + card.status" 
        (click)="selectedCardType = card.cardType">
        <span [ngClass]="getCardButtonIcon(card.cardType)"></span>
        {{ card.label }}
      </button>
    </div>
    <div class="family-wrapper">
      <div class="family">
        <div class="family__header">
          <div>
            <div class="family__title">{{ 'pages.user-cards.family.members.title' | translate }}</div>
            <div class="family__subtitle" *ngIf="maxFamilyMembers > 0">{{ 'pages.user-cards.family.members.subtitle' | translate: { max: maxFamilyMembers } }}</div>
          </div>
          <div>
            <button class="bciti-link" (click)="onMyFamilyEdit()">
              {{ 'pages.user-cards.family.members.edit' | translate }}
            </button>
          </div>
        </div>
        <div class="family-members">
          <app-family-member-button
            [firstName]="userRecord?.firstName"
            [lastName]="userRecord?.lastName"
            [picture]="userRecord?.picture || 'https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png'"
            [active]="selectedProfile === userRecord?.id"
            (click)="selectSelf()">
          </app-family-member-button>
          <app-family-member-button
            *ngFor="let member of family"
            [firstName]="member.firstName"
            [lastName]="member.lastName"
            [picture]="member.picture || 'https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png'"
            [active]="selectedProfile === member?._id"
            [showWarning]="profileIsMissingPrimaryCard(member)"
            (click)="selectFamilyMember(member?._id)">
          </app-family-member-button>
          <!-- Liste des invitations en attente-->
          <app-family-member-button
            *ngFor="let link of inviteFamilyLinks"
            [firstName]="link.firstName"
            [lastName]="link.lastName"
            [picture]="link.picture || 'https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png'"
            [active]="selectedProfile === link?._id"
            linkStatus="INVITED">
          </app-family-member-button>
          <!-- Liste des approbations en attente-->
          <app-family-member-button
            *ngFor="let link of pendingFamilyLinks"
            [firstName]="link.firstName"
            [lastName]="link.lastName"
            [picture]="link.picture || 'https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png'"
            [active]="selectedProfile === link?._id"
            linkStatus="PENDING">
          </app-family-member-button>
          <button *ngIf="totalFamilyMembers < maxFamilyMembers || maxFamilyMembers === 0" class="add-family" (click)="onLinkFamiliyMember()">
            <span class="add-family__plus">
              <span class="icon-plus"></span>
            </span>
            <span class="add-family__text">
              {{ 'pages.user-cards.common.button.add' | translate }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
